import { Link } from 'react-router-dom';
import { Trans } from '@lingui/macro';
import { Button } from 'components/ui/button';

export default function PageNotFound(props) {
    return (
        <div className="mt-24 flex flex-col items-center justify-center">
            <h1 className="text-3xl font-normal text-foreground">
                <Trans>Page not Found</Trans>
            </h1>
            <div className="h-8" />
            <Button asChild variant="outline">
                <Link to="/">
                    <Trans>Go to Home</Trans>
                </Link>
            </Button>
        </div>
    );
}
